var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.57995C0 4.32438 0.201472 4.11719 0.45 4.11719H3.6C3.84853 4.11719 4.05 4.32438 4.05 4.57995V9.20762C4.05 9.4632 3.84853 9.67039 3.6 9.67039H0.45C0.201472 9.67039 0 9.4632 0 9.20762V4.57995Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7998 11.0585C1.7998 10.8029 2.00128 10.5957 2.2498 10.5957H4.61897C4.81579 10.5957 4.98978 10.7272 5.04849 10.9204L7.01723 17.3992C7.10779 17.6972 6.89131 18 6.58772 18H2.2498C2.00128 18 1.7998 17.7928 1.7998 17.5372V11.0585Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9502 4.4149C4.9502 4.23342 5.05334 4.0687 5.21398 3.99361L13.5778 0.0840299C14.1737 -0.194513 14.8502 0.253474 14.8502 0.926604V12.8604C14.8502 13.5336 14.1737 13.9815 13.5778 13.703L5.21398 9.79342C5.05334 9.71833 4.9502 9.5536 4.9502 9.37213V4.4149Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4.15625C17.0269 4.3766 18 5.51821 18 6.89399C18 8.26974 17.0269 9.41089 15.75 9.63127V4.15625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu4);
export default __webpack_public_path__ + "static/media/menu4.d085d2646dbb3d7a8be0ec4c1f96f653.svg";
export { ForwardRef as ReactComponent };